import { Col, Row } from "antd";
import DashboardTemplate from "../../templates/Dashboard";
import Header from "../../atoms/Header";
import MyProfileCard from "./Components/MyProfileCard";
import ChangePassword from "./Components/ChangePassword";
import PreferredLanguage from "./Components/PreferredLanguage";
import MyJobDetails from "./Components/MyJobDetails";
import { useAppSelector } from "../../config/hooks";
import { NeedHelp } from "../../atoms/CustomIcons";

export default function MyProfile() {
  const myProfileData = useAppSelector((state) => state?.myProfile?.userData);

  return (
    <DashboardTemplate loading={myProfileData?.loader}>
      <Header
        title="My Profile"
        description="View and manage your user account details."
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
      />
      <div className="maxWidth">
        <Row gutter={20}>
          <Col md={24} lg={24} xl={8} xs={24}>
            <MyProfileCard data={myProfileData?.data} />
            <MyJobDetails />
          </Col>
          <Col md={24} lg={24} xl={16} xs={24}>
            <ChangePassword data={myProfileData?.data} />
            <PreferredLanguage />
          </Col>
        </Row>
      </div>
    </DashboardTemplate>
  );
}
